export default "/_next/static/images/membershipBackground-22586cdb3d1d34cdf8ba0ae9cab8062f.png";